module.exports = __webpack_public_path__ + "img/wenjuan.239ab2c5.png";